// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invisible-file-input {
    visibility: hidden;
    height: 0;
    width: 0;
}

.avatar-body__file-choose{
    display: flex;
    justify-content: center;
}

.avatar-body__image-preview{
    display: flex;
    justify-content: center;
}

.avatar-editor-window .modal-header{
    width: 100%;
    display: flex;
    justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/changable-image/ChangableImage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B","sourcesContent":[".invisible-file-input {\r\n    visibility: hidden;\r\n    height: 0;\r\n    width: 0;\r\n}\r\n\r\n.avatar-body__file-choose{\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.avatar-body__image-preview{\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.avatar-editor-window .modal-header{\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
